module.exports = __webpack_public_path__ + "static/media/zapai2.b4439869.png";